import React, { useCallback, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { makeGetTaskTitle, makeGetTaskTitleIdentifier } from '../../../../../redux/tasks/taskEntities/selectors';
import { editTaskAction, openTaskAction } from '../../../../../redux/tasks/actions';

const ConnectedTaskTitle = ({ onClick, taskId, taskTitle, titleIdentifier, openOnClick }) => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState(taskTitle);
  const [isEdit, setIsEdit] = useState(false);

  const handleChange = useCallback((e) => setTitle(e.target.value), []);

  const saveTaskTitle = useCallback(() => {
      if (title.trim().length <= 0) {
        setTitle(taskTitle);
        setIsEdit(false);
        return;
      }
  
      if (title === taskTitle) {
        setIsEdit(false);
        return;
      }
  
      dispatch(
        editTaskAction({
          _id: taskId,
          taskTitle: title,
        }),
      );
      setIsEdit(false);
    }, [taskId, taskTitle, title]);
  
    const handleKeydown = useCallback(
      (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          saveTaskTitle();
        }
      },
      [saveTaskTitle],
    );

  const handleTaskClick = useCallback(async () => {
    if (!openOnClick) {
      setIsEdit(true);
      return;
    }

    if (typeof onClick === 'function') {
      onClick(taskId);
      return;
    }

    dispatch(openTaskAction(true, titleIdentifier, taskId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClick, openOnClick, taskId, titleIdentifier]);

  return (
    <div className="w-full">
      {isEdit ? (
        <input
          autoFocus
          value={title}
          onChange={handleChange}
          onBlur={saveTaskTitle}
          className="listview-task-title-input"
          onKeyDown={handleKeydown}
        />
      ) : (
        <div
          onClick={handleTaskClick}
          title={taskTitle}
          className={`listview-task-title ${openOnClick ? 'cursor-pointer hover:text-blue-600 hover:underline underline-offset-2' : 'cursor-text'}`}
        >
          {taskTitle}
        </div>
      )}
    </div>
  );
};

const makeMapStateToProps = () => {
  const getTaskTitle = makeGetTaskTitle();
  const getTaskTitleIdentifier = makeGetTaskTitleIdentifier();
  return (state, props) => ({
    taskTitle: getTaskTitle(state, props),
    titleIdentifier: getTaskTitleIdentifier(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskTitle);
